import { render, staticRenderFns } from "./RtmToHubDetails.vue?vue&type=template&id=ef54a5e8&scoped=true&"
import script from "./RtmToHubDetails.vue?vue&type=script&lang=js&"
export * from "./RtmToHubDetails.vue?vue&type=script&lang=js&"
import style0 from "./RtmToHubDetails.vue?vue&type=style&index=0&id=ef54a5e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef54a5e8",
  null
  
)

export default component.exports